import React from 'react';
import PropTypes from 'prop-types';
import { FaRegCheckCircle } from 'react-icons/fa';
import { useUserContext } from 'App/contexts/UserContext';

const BranchNameCell = ({ row, value }) => {
    const user = useUserContext();
    const { BranchID: branchId } = user;

    return (
        <>
            {value} {row.original.ID === branchId && <FaRegCheckCircle className="text-success" />}
        </>
    );
};

BranchNameCell.propTypes = {
    value: PropTypes.string.isRequired,
    row: PropTypes.shape({
        original: PropTypes.shape({
            ID: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default BranchNameCell;
